<template>
  <div>
    <b-modal
      id="modal-search"
      title="Search People"
      :busy = "true"
      return-focus="body"
      
    >
    <app-people-search action="navToPerson"></app-people-search>
    
      
    </b-modal>
  </div>
</template>

<script>

import PeopleSearch from "./PeopleSearch"
// this used in local dev set to empty string for productoin
/* exported variableName */
export default {
components:{
    appPeopleSearch:PeopleSearch,
    },
  
  
};
</script>
